import {RegistroEntrenador } from '../../system/RegistroEntrenador/RegistroEntrenador';
import CustomForm from '../../lib/FormValidator/Form/CustomForm'
import { RegistroEntrenadorAntecedente } from '../../system/RegistroEntrenadorAntecedente/RegistroEntrenadorAntecedente'
import { RegistroEntrenadorAntecedenteAssertions } from '../../system/RegistroEntrenadorAntecedente/RegistroEntrenadorAntecedenteAssertions'
class RegistroEntrenadorAntecedenteForm extends CustomForm {
    protected constructor(
    reante_id: string,
    reante_reid: string,
    reante_detalle: string,
    reante_tipo: string)
    {const rea = RegistroEntrenadorAntecedenteAssertions.build()
    super("RegistroEntrenadorAntecedente", rea)
    this.addInputAsserted('reante_id', reante_id)
    this.addInput('reante_reid', reante_reid)
    this.addInput('reante_detalle', reante_detalle)
    this.addInput('reante_tipo', reante_tipo)
}

private static build( reante_id: string,
reante_reid: string,
reante_detalle: string,
reante_tipo: string ) {
    return new this( reante_id,
    reante_reid,
    reante_detalle,
    reante_tipo )
}

static initialize() {
    return this.build( 'new',
    '',
    '',
    '' )
}

static with(entity: RegistroEntrenadorAntecedente) {
    return this.build(entity.getId(),
    entity.getReid(),
    entity.getDetalle(),
    entity.getTipo())
}

getIdInput() { return this.getInputByName('reante_id') }

getReidInput() { return this.getInputByName('reante_reid') }

getDetalleInput() { return this.getInputByName('reante_detalle') }

getTipoInput() { return this.getInputByName('reante_tipo') }



toRegistroEntrenadorAntecedente(): RegistroEntrenadorAntecedente {
    return RegistroEntrenadorAntecedente.createFrom(
    this.getIdInput().getValue(),
    this.getReidInput().getValue(),
    this.getDetalleInput().getValue(),
    this.getTipoInput().getValue() )
}

}

export default RegistroEntrenadorAntecedenteForm
